/** Shared atlas forms; widths and heights are visual proportions, not new textures. */
export const ACCENT_FORMS=[
 'hibiscus','daisies','bells','bird-of-paradise','lavender','ginger','stars','coral',
 'round-shrub','feather-fern','berries','broadleaf','low-fern','airy-bush','pink-tips','cream-bush',
] as const;
export const ACCENT_SIZES=[40,36,42,56,48,52,40,32,42,56,40,54,32,54,46,56] as const;
/** Shared pixel rustle loop; broad continuous rooted waving remains separate. */
export const ACCENT_FRAMES=14;
